var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('decision-log-inline-row',{attrs:{"count":_vm.decisions.length,"is-loading":_vm.isLoading,"is-panel-open":_vm.isPanelOpen},on:{"open":_vm.openPanel,"close":_vm.closePanel}}),_vm._v(" "),_c('decision-log-panel',{attrs:{"open":_vm.isPanelOpen,"decisions":_vm.decisions,"is-loading":_vm.isLoading},on:{"close":_vm.closePanel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }